import axios from "axios";
import privateAxios from "./interceptor/privateAxios";

const URL = process.env.REACT_APP_API_URL;

export const DEFAULT_URL = `${URL}/api/v1`;

// Axios instance for general JSON requests
const http = axios.create({
  baseURL: `${DEFAULT_URL}/`,
  headers: {
    "Content-Type": "application/json",
  },
});

const formDataHttp = axios.create({
  baseURL: `${DEFAULT_URL}/`,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});
privateAxios(http);
privateAxios(formDataHttp);

export { http, formDataHttp };
